const translations = {
  common: {
    search: 'Suchen',
    searching: 'Suche',
    signIn: 'Anmelden',
    register: 'Registrieren',
    myAccount: 'Mein Konto',
    support: 'Support',
    followUs: 'Folgen Sie uns auf X/Twitter',
    proMembership: 'Pro-Mitgliedschaft',
    new: 'Neu',
    proMember: 'Pro-Mitglied',
    upgrade: 'Upgrade',
    subscribe: 'Abonnieren',
    manage: 'Verwalten',
    cancel: 'Abbrechen',
    close: 'Schließen',
    or: 'Oder',
    email: 'E-Mail-Adresse',
    continue: 'Fortfahren',
    submit: 'Absenden',
    billing: 'Abrechnung',
    sort: 'Sortieren',
    language: 'Sprache',
    selectLanguage: 'Sprache auswählen',
    searchPlaceholder: 'Suchen...',
    cards: 'Karten',
    previous: 'Zurück',
    next: 'Weiter',
    pagination: 'Seitennummerierung',
    back: 'Zurück',
    backToSets: 'Zurück zu Sets',
    error: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
    home: 'Startseite',
    sets: 'Sets',
    login: 'Anmelden',
    loginRequired: 'Bitte melden Sie sich an, um auf diese Funktion zuzugreifen',
    adding: 'Hinzufügen...',
  },
  languages: {
    default: 'Standard',
    any: 'Beliebig',
    english: 'Englisch',
    spanish: 'Spanisch',
    french: 'Französisch',
    german: 'Deutsch',
    italian: 'Italienisch',
    portuguese: 'Portugiesisch',
    japanese: 'Japanisch',
    korean: 'Koreanisch',
    russian: 'Russisch',
    simplified_chinese: 'Vereinfachtes Chinesisch',
    traditional_chinese: 'Traditionelles Chinesisch',
    hebrew: 'Hebräisch',
    latin: 'Latein',
    ancient_greek: 'Altgriechisch',
    arabic: 'Arabisch',
    sanskrit: 'Sanskrit',
    phyrexian: 'Phyrexianisch',
    quenya: 'Quenya',
  },
  filters: {
    show: '✨ Pro-Filter anzeigen',
    hide: '✨ Pro-Filter ausblenden',
  },
  search: {
    showing_start: 'Zeige',
    showing_to: 'bis',
    showing_of: 'von',
    showing_results: 'Ergebnissen',
    noResults: 'Keine Ergebnisse gefunden.',
    useSearchTip: 'Verwenden Sie die Suche oben auf der Seite, um eine Karte zu finden.',
  },
  sort: {
    nameAsc: 'Name (A bis Z)',
    nameDesc: 'Name (Z bis A)',
    cmcAsc: 'Manawert (Niedrig zu Hoch)',
    cmcDesc: 'Manawert (Hoch zu Niedrig)',
    usdAsc: 'Preis (Niedrig zu Hoch)',
    usdDesc: 'Preis (Hoch zu Niedrig)',
    rarityAsc: 'Seltenheit (Gewöhnlich zu Mythisch)',
    rarityDesc: 'Seltenheit (Mythisch zu Gewöhnlich)',
    releasedDesc: 'Erscheinungsdatum (Neueste zuerst)',
    releasedAsc: 'Erscheinungsdatum (Älteste zuerst)',
  },
  pages: {
    search: {
      heading: 'MTG Kartensuche',
    },
    sets: {
      heading: 'Kartensets',
      latestSets: 'Neueste Sets',
      upcomingSets: 'Kommende Sets',
      allSets: 'Alle Sets',
      noResults: 'Keine Ergebnisse gefunden.',
    },
    set: {
      notFound: 'Set nicht gefunden.',
      noCards: 'Keine Karten in diesem Set gefunden.',
      addAll: '{{count}} Karten zur Proxy-Liste hinzufügen',
      addedToList: '{{count}} Karten zur Proxy-Liste hinzugefügt',
    },
    tokens: {
      heading: 'Spielmarken',
    },
    emblems: {
      heading: 'Embleme',
    },
    import: {
      heading: 'Karten zur Proxy-Liste importieren',
      description: 'Geben Sie die Namen aller Karten ein, die Sie zur Proxy-Liste hinzufügen möchten.',
    },
    topProxies: {
      heading: 'Top-Proxies',
      description: 'Hier sind die 50 beliebtesten MTG Proxy-Karten auf TCG Stacked.',
    },
  },
  theme: {
    light: 'Hell',
    dark: 'Dunkel',
    toggle: 'Theme umschalten',
  },
  cta: {
    title: 'Bereit loszulegen?',
    subtitle: 'Beginnen Sie noch heute mit dem Erstellen von Karten-Proxies.',
    searchByCard: 'Nach Karte suchen',
    searchBySet: 'Nach Set suchen',
  },
  nav: {
    magicTheGathering: 'Magic: The Gathering',
    pokemon: 'Pokémon',
    sets: 'Sets',
    tokens: 'Spielmarken',
    emblems: 'Embleme',
    import: 'Importieren',
    topProxies: 'Top-Proxies',
    customCards: 'Eigene Karten',
    deckBuilder: 'Deck-Builder',
    buildDeck: 'Deck erstellen',
    publicDecks: 'Öffentliche Decks',
    favoriteDeck: 'Meine Lieblings-Decks',
    articles: 'Artikel',
    feedback: 'Feedback teilen',
    collection: 'Meine Sammlung',
    pokemonSets: 'Pokémon Sets',
    pokemonSearch: 'Pokémon Karten suchen',
  },
  seo: {
    collection: {
      title: 'Meine Kartensammlung | TCG Stacked',
      description: 'Verwalten Sie Ihre persönliche Kartensammlung. Verfolgen, organisieren und bewerten Sie Ihre Magic: The Gathering Karten an einem Ort.',
    },
    home: {
      title: 'TCG Stacked - Proxy Sammelkartenspiel Karten',
      description: 'Zugriff auf eine umfangreiche Bibliothek von Sammelkartenspiel Proxy-Karten. Einfach Kartenbilder für Casual Play ansehen und drucken. Beginnen Sie jetzt mit dem Bau Ihres Traumdecks!',
    },
    sets: {
      title: 'Kartensets - TCG Stacked',
      description: 'Durchsuchen Sie alle Sammelkartenspiel-Sets und drucken Sie Proxies für Ihr Deck.',
    },
    tokens: {
      title: 'Spielmarken - TCG Stacked',
      description: 'Verbessern Sie Ihre Spiele mit verschiedenen Proxy-Spielmarken.',
    },
    emblems: {
      title: 'Embleme - TCG Stacked',
      description: 'Drucken Sie Emblem-Proxykarten für Ihr Deck.',
    },
    search: {
      title: 'MTG-Karten suchen - MTG Proxies',
      description: 'Finden und drucken Sie MTG-Proxykarten mühelos. Nutzen Sie unser Suchwerkzeug, um auf eine umfangreiche Datenbank zuzugreifen und verbessern Sie Ihr Magic: The Gathering Deck mit Proxies.',
    },
    support: {
      title: 'Support - MTG Proxies',
      description: 'Wenn Sie Fragen, Feedback haben oder eine Spielmarke/ein Emblem hinzufügen möchten, senden Sie uns eine E-Mail.',
    },
    articles: {
      title: 'Artikel - MTG Proxies',
      description: 'Artikel über Magic: The Gathering und Proxy-Karten.',
    },
    import: {
      title: 'Importieren - MTG Proxies',
      description: 'Importieren Sie eine Liste von Karten, um Ihre Magic: The Gathering Proxies zu drucken.',
    },
    topProxies: {
      title: 'Top-Proxies - MTG Proxies',
      description: 'Sehen Sie die beliebtesten Magic: The Gathering Proxy-Karten.',
    },
    customCards: {
      title: 'Eigene Karten - MTG Proxies',
      description: 'Erstellen Sie Ihre eigenen Magic: The Gathering Proxy-Karten.',
    },
    login: {
      title: 'Anmelden - MTG Proxies',
      description: 'Melden Sie sich bei Ihrem Konto an, um Ihre eigenen Karten, Decklisten und mehr zu verwalten.',
    },
    register: {
      title: 'Registrieren - MTG Proxies',
      description: 'Registrieren Sie sich, um Ihre eigenen Karten, Decklisten und mehr zu verwalten.',
    },
    termsOfService: {
      title: 'Nutzungsbedingungen - MTG Proxies',
      description: 'Lesen Sie die Nutzungsbedingungen der Website.',
    },
    privacyPolicy: {
      title: 'Datenschutzerklärung - MTG Proxies',
      description: 'Lesen Sie die Datenschutzerklärung der Website.',
    },
    account: {
      title: 'Konto - MTG Proxies',
      description: 'Verwalten Sie Ihr Konto.',
    },
    proMembership: {
      title: 'Pro-Mitgliedschaft - MTG Proxies',
      description:
        'Upgraden Sie zur Pro-Mitgliedschaft für ein verbessertes Sammelkartenspiel-Erlebnis mit erweiterten Druckoptionen, werbefreiem Surfen, unbegrenztem Deck-Speicher und exklusiven Kartenanpassungsfunktionen für Magic: The Gathering und Pokémon.',
    },
    deckBuilder: {
      title: 'Deck-Builder - MTG Proxies',
      description: 'Erstellen und verwalten Sie Ihre Magic: The Gathering Decks.',
    },
    deckEditor: {
      title: 'Deck-Editor - MTG Proxies',
      description: 'Erstellen und bearbeiten Sie Ihre Magic: The Gathering Decks.',
    },
    publicDecks: {
      title: 'Öffentliche Decks - MTG Proxies',
      description: 'Durchsuchen und entdecken Sie öffentliche MTG-Decks, die von der Community geteilt wurden.',
    },
    pokemonHome: {
      title: 'Pokémon Sammelkartenspiel | TCG Stacked',
      description: 'Zugriff auf eine umfangreiche Bibliothek von Pokémon Sammelkartenspiel-Karten. Einfach Pokémon-Kartenbilder für Casual Play ansehen und drucken. Beginnen Sie jetzt mit dem Bau Ihres Traumdecks!',
    },
    pokemonSets: {
      title: 'Pokémon Kartensets | TCG Stacked',
      description: 'Erkunden Sie unsere umfassende Sammlung von Pokémon TCG-Sets vom Basis-Set bis zu den neuesten Erweiterungen. Finden und drucken Sie hochwertige Pokémon-Proxies, organisiert nach Set für Ihr Casual Gameplay.',
    },
    pokemonSetDetail: {
      title: '{{setName}} | Pokémon Kartenset | TCG Stacked',
      description: 'Durchsuchen Sie alle Karten aus dem Pokémon-Kartenset {{setName}}. Finden und drucken Sie Pokémon-Proxy-Karten für Casual Play.',
    },
    pokemonSearch: {
      title: 'Pokémon Kartensuche | TCG Stacked',
      description: 'Suchen Sie nach Pokémon-Karten. Finden und drucken Sie Pokémon-Proxy-Karten für Casual Play und Deck-Tests.',
    },
    pokemonCard: {
      title: '{{cardName}} | Pokémon TCG | TCG Stacked',
      description: 'Details für {{cardName}} aus {{setName}} anzeigen. Drucken Sie diese Pokémon-Karte für Casual Play und Deck-Tests.',
    },
  },
  pro: {
    pricing: {
      title: 'Steigern Sie Ihr MTG Proxy-Erlebnis',
      subtitle: 'Werden Sie Pro und genießen Sie ein werbefreies Premium-Erlebnis mit exklusiven Funktionen, die Ihre Proxies auf die nächste Stufe heben!',
      monthlyPlan: 'Monatlicher Power-Boost',
      yearlyPlan: 'Jährlicher Spar-Vorteil',
      monthlyPrice: '5,00 $ pro Monat',
      yearlyPrice: '40,00 $ pro Jahr',
      subscribeMonthly: 'Jetzt Starten',
      subscribeYearly: 'Jährlich Sparen',
      signInToSubscribe: 'Anmelden und Pro freischalten',
      manageSubscription: 'Ihre Pro-Vorteile verwalten',
      nextBillingDate: 'Ihr nächstes Zahlungsdatum',
      benefitsEndDate: 'Pro-Zugang bis zum',
      viewInvoice: 'Beleg anzeigen',
      changePlan: 'Ihren Plan wechseln',
      reactivate: 'Pro-Vorteile wiederherstellen',
      active: 'Aktiv und Erfolgreich',
      cancelled: 'Gekündigt',
      freeTrial: 'Kostenlose Testversion',
      freeTrialEnds: 'Kostenlose Testversion endet',
      startFreeTrial: '7-tägige kostenlose Testversion starten',
      signInForFreeTrial: 'Anmelden für 7-tägige kostenlose Testversion',
      current: 'Aktuell',
      subscribe: 'Abonnieren',
    },
    benefits: {
      title: 'Warum Pro mit TCG Stacked wählen?',
      subtitle: 'Schließen Sie sich Hunderten von Spielern an, die ihr MTG-Erlebnis mit diesen exklusiven Pro-Funktionen verbessert haben!',
      noAds: {
        title: 'Sauberes, werbefreies Erlebnis',
        description: 'Verabschieden Sie sich von Unterbrechungen! Genießen Sie eine makellose Oberfläche ohne Anzeigen, Banner oder Pop-ups. Pures MTG-Proxy-Vergnügen.',
      },
      darkMode: {
        title: 'Epischer Dunkelmodus',
        description: 'Angenehm für die Augen und stilvoll! Perfekt für Nachteulen und Marathon-Proxy-Sessions bei jeder Lichtsituation.',
      },
      advancedSearch: {
        title: 'Pro-Level Suchmagie',
        description: 'Finden Sie genau, was Sie brauchen, mit leistungsstarken Filtern! Filtern Sie nach Farbidentität, Seltenheit, Kartentyp und mehr, um das perfekte Deck zu bauen.',
      },
      multipleDecks: {
        title: 'Unbegrenzter Deck-Bau',
        description: 'Ein Paradies für Deck-Builder! Erstellen und speichern Sie so viele Decks, wie Sie möchten – vom Casual-Spaß bis zu wettbewerbsfähigen Powerhouses.',
      },
      futureFeatures: {
        title: 'Erster Zugang zu neuen Funktionen',
        description: 'Seien Sie an der Spitze der Entwicklung! Pro-Mitglieder erhalten immer zuerst Zugriff auf spannende neue Funktionen, sobald sie veröffentlicht werden.',
      },
      cancelAnytime: {
        title: 'Null Risiko, voller Gewinn',
        description: 'Volle Freiheit! Keine langfristigen Verträge oder versteckten Gebühren. Kündigen Sie mit einem Klick, wann immer Sie möchten.',
      },
      prioritySupport: {
        title: 'VIP-Support-Zugang',
        description: 'Überspringen Sie die Warteschlange! Ihre Fragen und Anliegen erhalten bevorzugte Behandlung durch unser engagiertes Support-Team.',
      },
    },
    features: {
      unlimitedDecks: 'Unbegrenzte MTG & Pokémon Deck-Erstellung',
      noAds: 'Keine Werbung',
      prioritySupport: 'VIP-Support-Zugang',
      darkMode: 'Stilvolle Dunkelmodus-Oberfläche',
      advancedSearch: 'Pro-Suchfilter für alle TCGs',
      aiCustomization: 'KI-Kartenanpassung für alle TCGs',
      futureFeatures: 'Exklusive kommende Funktionen',
      cancelAnytime: 'Unkomplizierte Kündigung',
    },
    promotion: {
      title: 'Entfesseln Sie unbegrenzte Deck-Erstellung',
      description: 'Brechen Sie die Grenzen! Upgraden Sie jetzt auf Pro und bauen Sie so viele Decks, wie Ihre Fantasie erlaubt.',
      customizeTitle: 'Transformieren Sie Karten mit KI-Magie',
      customizeDescription: 'Upgraden Sie auf Pro und erstellen Sie täglich bis zu 5 individuelle Kartenvariationen mit unserer fortschrittlichen KI-Technologie!',
      banner: 'Testen Sie Pro 7 Tage kostenlos! Keine Werbung, Dunkelmodus, unbegrenzte Decks und mehr.',
      tryNow: 'Jetzt Testen',
    },
    account: {
      title: 'Ihre Pro-Mitgliedschaft',
      description: 'Verwalten Sie Ihre Premium-Vorteile',
      subscribeToPro: 'Jetzt auf Pro upgraden',
    },
  },
  auth: {
    signIn: {
      title: 'Melden Sie sich bei Ihrem Konto an',
      withGoogle: 'Mit Google fortfahren',
      withEmail: 'Oder fortfahren mit',
      sendMagicLink: 'Magic Link senden',
      noAccount: 'Noch kein Konto?',
      checkEmail: 'Überprüfen Sie Ihre E-Mail für einen Anmeldelink',
      errors: {
        failed: 'Anmeldung fehlgeschlagen',
        failedGoogle: 'Anmeldung mit Google fehlgeschlagen',
        failedEmail: 'Anmeldung per E-Mail fehlgeschlagen',
        noEmail: 'Keine E-Mail gefunden',
      },
      terms: 'Mit der Anmeldung bestätige ich, dass ich die',
    },
    register: {
      title: 'Erstellen Sie Ihr Konto',
      haveAccount: 'Haben Sie bereits ein Konto?',
      terms: 'Mit der Erstellung eines Kontos bestätige ich, dass ich die',
    },
    common: {
      termsOfService: 'Nutzungsbedingungen',
      privacyPolicy: 'Datenschutzerklärung',
      and: 'und',
    },
  },
  home: {
    hero: {
      title: 'Proxy',
      rotatingWords: ['Karten', 'Spielmarken', 'Embleme', 'Planeswalker', 'Kommandeure', 'Länder', 'Kreaturen', 'Artefakte', 'Verzauberungen', 'Spontanzauber'],
      description: 'TCG Stacked hilft dir dabei, Sammelkartenspiel Proxy-Karten für deine Casual-Decks kostenlos zu erstellen!',
      search: {
        cards: {
          tab: 'Karten',
          placeholder: 'Nach Sammelkarten suchen...',
          error: 'Fehler beim Laden zufälliger Karten',
        },
        sets: {
          tab: 'Editionen',
          placeholder: 'Nach Sammelkartenspiel-Editionen suchen...',
        },
        tokens: {
          tab: 'Spielmarken',
          placeholder: 'Nach Sammelkartenspiel-Spielmarken suchen...',
        },
        button: 'Suchen',
        hint: {
          cards: 'Drücke Enter oder klicke auf Suchen, um deine Karten zu finden',
          sets: 'Drücke Enter oder klicke auf Suchen, um deine Editionen zu finden',
          tokens: 'Drücke Enter oder klicke auf Suchen, um deine Spielmarken zu finden',
        },
        aria: {
          searchIcon: 'Suchsymbol',
          searchInput: {
            cards: 'Nach Karten suchen',
            sets: 'Nach Editionen suchen',
            tokens: 'Nach Spielmarken suchen',
          },
        },
      },
      images: {
        cardAlt: 'Magic-Kartenbild',
      },
      processedCount: '🎉 Wir haben über {{count}} kostenlose Proxies für die Community erstellt! 🎉',
    },
    features: {
      section1: {
        badge: 'Proxies Drucken',
        title: 'MTG Proxy-Karten Drucken',
        subtitle: 'Füge Karten deiner Druckliste hinzu, drucke sie aus und verwende sie noch heute in deinen Decks!',
        features: [
          {
            name: 'Füge Karten deiner Druckliste hinzu',
            description: 'Suche nach beliebigen Karten über die Suchseite oder durchsuche die Editionen und füge die gewünschten Karten deiner Druckliste hinzu.',
          },
          {
            name: 'Drucke deine Karten',
            description: 'Sobald du alle gewünschten Karten deiner Druckliste hinzugefügt hast, kannst du sie ausdrucken und in deinen Decks verwenden.',
          },
          {
            name: 'Verwende sie in deinen Decks',
            description: 'Sobald du deine Karten ausgedruckt hast, kannst du sie in deinen Decks verwenden. Schneide sie aus und klebe sie auf ein Standardland oder verwende eine Hülle mit einem Standardland darin.',
          },
        ],
        images: {
          cartScreenshot: 'Warenkorb-Screenshot zeigt, wie man Karten zur Druckliste hinzufügt',
        },
      },
      section2: {
        badge: 'Deck-Builder',
        title: 'Magic: The Gathering Decks Erstellen und Verwalten',
        subtitle: 'Erstelle und verwalte deine eigenen Decks oder durchstöbere öffentliche Decks der Community.',
        features: [
          {
            name: 'Verwalte deine MTG Decks',
            description: 'Alle Benutzer können ein MTG-Deck erstellen und verwalten. Pro-Mitglieder können unbegrenzt viele Decks erstellen.',
          },
          {
            name: 'Drucke deine Karten',
            description: 'Sobald du alle gewünschten Karten deinem Deck hinzugefügt hast, kannst du sie auf einmal deiner Druckliste hinzufügen.',
          },
          {
            name: 'Durchsuche Öffentliche Decks',
            description: 'Füge komplette Decks der Community deiner Druckliste hinzu, um neue Decks einfach zu testen.',
          },
        ],
        images: {
          deckBuilderScreenshot: 'Deck-Builder-Oberfläche zeigt, wie man Decks verwaltet',
        },
      },
    },
  },
  footer: {
    copyright: 'TCG Stacked, Alle Rechte vorbehalten.',
    disclaimer: 'TCG Stacked wird nicht von irgendeinem Sammelkartenspiel-Herausgeber produziert, unterstützt oder ist damit verbunden.',
    affiliate: 'Als TCGplayer-Affiliate-Partner kann TCG Stacked eine Provision für qualifizierte Käufe erhalten.',
    builtBy: 'Erstellt von',
    minnerLabs: 'Minner Labs',
    privacyPolicy: 'Datenschutzrichtlinie',
    termsOfService: 'Nutzungsbedingungen',
    support: 'Support',
    articles: 'Artikel & Anleitungen',
  },
  sort: {
    nameAsc: 'Name (A bis Z)',
    nameDesc: 'Name (Z bis A)',
    cmcAsc: 'Manawert (Niedrig zu Hoch)',
    cmcDesc: 'Manawert (Hoch zu Niedrig)',
    usdAsc: 'Preis (Niedrig zu Hoch)',
    usdDesc: 'Preis (Hoch zu Niedrig)',
    rarityAsc: 'Seltenheit (Gewöhnlich zu Mythisch)',
    rarityDesc: 'Seltenheit (Mythisch zu Gewöhnlich)',
    releasedDesc: 'Erscheinungsdatum (Neueste zuerst)',
    releasedAsc: 'Erscheinungsdatum (Älteste zuerst)',
  },
  pages: {
    search: {
      heading: 'Suchen',
    },
    sets: {
      heading: 'Kartensets',
      latestSets: 'Neueste Sets',
      upcomingSets: 'Kommende Sets',
      allSets: 'Alle Sets',
      noResults: 'Keine Ergebnisse gefunden.',
    },
    set: {
      notFound: 'Set nicht gefunden.',
      noCards: 'Keine Karten in diesem Set gefunden.',
      addAll: '{{count}} Karten zur Druckliste hinzufügen',
      addedToList: '{{count}} Karten zur Druckliste hinzugefügt',
    },
    tokens: {
      heading: 'Spielmarken',
    },
    emblems: {
      heading: 'Embleme',
    },
    import: {
      heading: 'Karten zur Druckliste importieren',
      description: 'Geben Sie die Namen aller Karten ein, die Sie zur Druckliste hinzufügen möchten.',
    },
    topProxies: {
      heading: 'Top-Proxies',
      description: 'Hier sind die 50 beliebtesten Magic: The Gathering Proxy-Karten auf MTG Proxies.',
    },
  },
  languages: {
    default: 'Standard',
    any: 'Alle',
    english: 'Englisch',
    spanish: 'Spanisch',
    french: 'Französisch',
    german: 'Deutsch',
    italian: 'Italienisch',
    portuguese: 'Portugiesisch',
    japanese: 'Japanisch',
    korean: 'Koreanisch',
    russian: 'Russisch',
    simplified_chinese: 'Vereinfachtes Chinesisch',
    traditional_chinese: 'Traditionelles Chinesisch',
    hebrew: 'Hebräisch',
    latin: 'Latein',
    ancient_greek: 'Altgriechisch',
    arabic: 'Arabisch',
    sanskrit: 'Sanskrit',
    phyrexian: 'Phyrexianisch',
    quenya: 'Quenya',
  },
  filters: {
    show: '✨ Pro-Filter anzeigen',
    hide: '✨ Pro-Filter ausblenden',
  },
  search: {
    showing_start: 'Zeige',
    showing_to: 'bis',
    showing_of: 'von',
    showing_results: 'Ergebnissen',
    noResults: 'Keine Ergebnisse gefunden.',
    useSearchTip: 'Verwenden Sie die Suche oben auf der Seite, um nach einer Karte zu suchen.',
  },
  advancedFilters: {
    colors: 'Farben',
    rarity: 'Seltenheit',
    cardTypes: 'Kartentypen',
    format: 'Format',
    manaValue: 'Manawert',
    cardName: 'Kartenname',
    cardText: 'Kartentext',
    specialCharacteristics: 'Besondere Eigenschaften',
    activeFilters: 'Aktive Filter',
    clearAll: 'Alle löschen',
    applyFilters: 'Filter anwenden',
    searchCardName: 'Kartenname suchen...',
    searchCardText: 'Kartentext suchen...',
    namePrefix: 'Name: ',
    manaPrefix: 'Mana: ',
    textPrefix: 'Text: ',
    removeFromFilter: '✕',
    selectLanguage: 'Sprache auswählen',
  },
  card: {
    addToPrintList: 'Zur Druckliste hinzufügen',
    removeFromPrintList: 'Von Druckliste entfernen',
    cardsInPrintList: 'Karte in Druckliste',
    cardsInPrintListPlural: 'Karten in Druckliste',
    buyOn: 'Auf TCGplayer kaufen',
    buyFor: 'Kaufen für ',
    viewDetails: 'Details anzeigen',
    type: 'Typ',
    manaCost: 'Manakosten',
    rarity: 'Seltenheit',
    artist: 'Künstler',
    collectorNumber: 'Sammlernummer',
    oracleText: 'Oracle-Text',
    youMightAlsoLike: 'Das könnte dir auch gefallen...',
    noRecommendations: 'Keine Empfehlungen verfügbar.',
    details: 'Details',
    rulings: 'Regeln',
    legality: 'Legalität',
    share: 'Teilen',
    favorite: 'Favorit',
    noRulings: 'Keine Regeln für diese Karte verfügbar.',
    noLegalityInfo: 'Keine Legalitätsinformationen für diese Karte verfügbar.',
    published: 'Veröffentlicht',
    legal: 'Legal',
    restricted: 'Eingeschränkt',
    banned: 'Verboten',
    format: 'Format',
    status: 'Status',
    viewMore: 'Mehr anzeigen',
    viewLess: 'Weniger anzeigen',
    customizeWithAI: 'Mit KI anpassen',
    otherVersions: 'Einzigartige Drucke',
    showUniqueVersions: 'Einzigartige Drucke anzeigen',
    hideUniqueVersions: 'Einzigartige Drucke ausblenden',
  },
  cart: {
    title: 'Druckliste',
    closePanel: 'Panel schließen',
    empty: 'Keine Proxies in der Druckliste.',
    addPadding: 'Abstand hinzufügen',
    paperSize: 'Papiergröße',
    scale: 'Skalierung',
    clearCardList: 'Liste leeren',
    print: 'Drucken',
    success: 'Erfolg!',
  },
  setsList: {
    showing: 'Zeige',
    to: 'bis',
    of: 'von',
    results: 'Ergebnissen',
    searchPlaceholder: 'Suchen...',
  },
  customizeCardModal: {
    title: 'Karte mit KI anpassen',
    description: 'Beschreiben Sie, wie Sie diese Karte anpassen möchten. Die KI wird eine neue Version generieren, während der Kartenrahmen und die Struktur beibehalten werden.',
    buttonText: 'Mit KI anpassen',
    placeholder: 'Beschreiben Sie Ihre benutzerdefinierte Kartenvariation...',
    generateButton: 'Benutzerdefinierte Karte generieren',
    generatingButton: 'Generiere...',
    addToPrintListButton: 'Zur Druckliste hinzufügen',
    successMessage: 'Benutzerdefinierte Karte zur Druckliste hinzugefügt',
    cancelledGeneration: 'Kartengenerierung abgebrochen',
    remainingGenerationsOne: '{{count}} verbleibende Generierung in diesem Monat',
    remainingGenerationsOther: '{{count}} verbleibende Generierungen in diesem Monat',
    error: {
      failed: 'Fehler beim Generieren der benutzerdefinierten Karte',
    },
  },
  feedback: {
    buttonLabel: 'Feedback',
    title: 'Teilen Sie Ihr Feedback',
    description: 'Wir schätzen Ihre Meinung, um TCG Stacked zu verbessern. Bitte teilen Sie uns Ihre Gedanken mit.',
    categoryLabel: 'Kategorie',
    categories: {
      bug: 'Fehlerbericht',
      feature: 'Funktionsanfrage',
      improvement: 'Verbesserungsvorschlag',
      general: 'Allgemeines Feedback',
      other: 'Sonstiges',
    },
    messageLabel: 'Ihr Feedback',
    messagePlaceholder: 'Bitte teilen Sie Ihre Gedanken, Vorschläge oder melden Sie ein Problem...',
    ratingLabel: 'Bewerten Sie Ihre Erfahrung (Optional)',
    emailLabel: 'E-Mail (Optional)',
    emailPlaceholder: 'ihre@email.com',
    emailHelp: 'Geben Sie Ihre E-Mail an, wenn Sie möchten, dass wir uns bei Ihnen melden.',
    submitting: 'Wird gesendet...',
    submitButton: 'Feedback senden',
    successMessage: 'Vielen Dank für Ihr Feedback!',
    errorMessage: 'Feedback konnte nicht gesendet werden. Bitte versuchen Sie es erneut.',
  },
  collection: {
    title: 'Meine Sammlung',
    loginRequired: 'Anmeldung erforderlich',
    loginMessage: 'Bitte melden Sie sich an, um Ihre Sammlung zu sehen',
    emptyCollection: 'Keine Karten gefunden',
    emptyCollectionMessage: 'Ihre Sammlung ist leer. Fügen Sie Karten von der Kartendetailseite hinzu oder verwenden Sie die Massenzufügen-Funktion.',
    noMatchingCards: 'Keine Karten entsprechen Ihren Filtern.',
    searchPlaceholder: 'Karten suchen...',
    sortBy: 'Sortieren nach',
    sortName: 'Name',
    sortPrice: 'Preis',
    sortDate: 'Hinzugefügt am',
    sortQuantity: 'Anzahl',
    filterRarity: 'Seltenheit',
    filterSet: 'Set',
    allRarities: 'Alle Seltenheiten',
    allSets: 'Alle Sets',
    filters: 'Filter',
    clearFilters: 'Filter zurücksetzen',
    sortAscending: 'Aufsteigend sortieren',
    sortDescending: 'Absteigend sortieren',
    bulkAdd: 'Massenzufügen',
    bulkAddTitle: 'Karten aus der Druckliste hinzufügen',
    bulkAddDescription: 'Fügen Sie alle Karten aus Ihrer Druckliste zu Ihrer Sammlung hinzu.',
    bulkAddCount: '{{count}} Karten werden zu Ihrer Sammlung hinzugefügt.',
    emptyCart: 'Ihre Druckliste ist leer',
    bulkAddSuccess: 'Karten zur Sammlung hinzugefügt',
    bulkAddError: 'Fehler beim Hinzufügen von Karten zur Sammlung',
    addToCollection: 'Zur Sammlung hinzufügen',
    addMore: 'Mehr hinzufügen',
    inCollection: 'In Sammlung',
    quickAdd: 'Schnell hinzufügen',
    searchCards: 'Karten suchen...',
    typeToSearch: 'Geben Sie mindestens 3 Zeichen ein, um zu suchen',
    noResults: 'Keine Ergebnisse gefunden',
    noCardSelected: 'Keine Karte ausgewählt',
    addCardToCollection: 'Karte zur Sammlung hinzufügen',
    addCardDescription: 'Geben Sie die Anzahl an, die Sie zu Ihrer Sammlung hinzufügen möchten.',
    quantity: 'Anzahl',
    price: 'Preis',
    addToCart: 'Zur Druckliste hinzufügen',
    addedToCart: 'Sammlung zur Druckliste hinzugefügt',
    stats: 'Sammlungsstatistiken',
    totalValue: 'Gesamtwert',
    filteredValue: 'Gefilterter Wert',
    cardCount: 'Kartenanzahl',
    totalCards: 'Karten insgesamt',
    uniqueCards: 'einzigartige Karten',
    filteredCards: 'gefilterte Karten',
    rarityBreakdown: 'Seltenheitsverteilung',
    // Export feature
    export: 'Sammlung exportieren',
    exporting: 'Exportiere...',
    exportSuccess: 'Sammlung erfolgreich exportiert',
    exportError: 'Fehler beim Exportieren der Sammlung',
    noCardsToExport: 'Keine Karten zum Exportieren',
    exportCardName: 'Kartenname',
    exportSet: 'Set',
    exportRarity: 'Seltenheit',
    exportQuantity: 'Anzahl',
    exportPrice: 'Preis',
    exportTotalValue: 'Gesamtwert',
    exportDateAdded: 'Hinzugefügt am',
    // Quick add feature
    quickAdd: 'Schnell hinzufügen',
    searchCards: 'Karten zum Hinzufügen suchen',
    typeToSearch: 'Geben Sie mindestens 3 Zeichen ein, um zu suchen',
    noResults: 'Keine Ergebnisse gefunden',
    noCardSelected: 'Keine Karte ausgewählt',
    addCardToCollection: 'Karte zur Sammlung hinzufügen',
    addCardDescription: 'Geben Sie die Anzahl an, die Sie zu Ihrer Sammlung hinzufügen möchten',
    quantity: 'Anzahl',
    price: 'Preis',
    // Insights
    insights: 'Sammlungseinblicke',
    noInsightsAvailable: 'Keine Einblicke für Ihre Sammlung verfügbar',
    insightsDescription: 'Detaillierte Statistiken über Ihre Sammlung',
    rarityDistribution: 'Seltenheitsverteilung',
    topSets: 'Top-Sets',
    priceDistribution: 'Preisverteilung',
    // Clear collection feature
    clearCollection: 'Sammlung löschen',
    clearCollectionConfirmTitle: 'Gesamte Sammlung löschen?',
    clearCollectionConfirmMessage: 'Diese Aktion kann nicht rückgängig gemacht werden. Alle Karten in Ihrer Sammlung werden dauerhaft entfernt.',
    // Edit card in collection
    editCardInCollection: 'Karte in Sammlung bearbeiten',
    editCardDescription: 'Aktualisieren Sie die Details dieser Karte in Ihrer Sammlung.',
    viewCardDetails: 'Kartendetails anzeigen',
    condition: 'Zustand',
    selectCondition: 'Zustand auswählen',
    language: 'Sprache',
    selectLanguage: 'Sprache auswählen',
    finish: 'Veredelung',
    selectFinish: 'Veredelung auswählen',
    purchasePrice: 'Kaufpreis',
    isProxy: 'Dies ist ein Proxy',
    saveChanges: 'Änderungen speichern',
    removeCard: 'Karte entfernen',
    cardRemoved: 'Karte aus Sammlung entfernt',
    errorRemovingCard: 'Fehler beim Entfernen der Karte aus der Sammlung',
    errorSavingChanges: 'Fehler beim Speichern der Änderungen an der Karte',
    // Landing page
    landing: {
      title: 'Verwalten Sie Ihre MTG-Sammlung',
      description: 'Behalten Sie den Überblick über alle Ihre Magic: The Gathering Karten an einem Ort mit unseren leistungsstarken Sammlungsverwaltungstools.',
      intro: 'Unser Sammlungsverwaltungssystem ermöglicht es Ihnen, Ihre gesamte Magic: The Gathering Kartensammlung einfach zu verfolgen, zu organisieren und zu bewerten. Erstellen Sie noch heute ein Konto, um loszulegen!',
      createAccount: 'Konto erstellen',
      getStarted: 'Jetzt loslegen',
      howItWorks: 'So funktioniert es',
      step1: 'Erstellen Sie ein kostenloses Konto, um auf Ihre persönliche Sammlung zuzugreifen',
      step2: 'Fügen Sie Karten manuell zu Ihrer Sammlung hinzu oder importieren Sie sie aus einer CSV-Datei',
      step3: 'Organisieren Sie Ihre Karten nach Set, Farbe, Seltenheit und mehr',
      step4: 'Verfolgen Sie den Wert Ihrer Sammlung im Laufe der Zeit',
      step5: 'Exportieren Sie Ihre Sammlungsdaten, wann immer Sie sie benötigen',
    },
    features: {
      track: {
        title: 'Verfolgen Sie Ihre Karten',
        description: 'Führen Sie ein detailliertes Inventar aller Ihrer Magic: The Gathering Karten an einem Ort',
      },
      organize: {
        title: 'Nach Set organisieren',
        description: 'Sortieren und filtern Sie Ihre Sammlung nach Set, Seltenheit, Farbe und mehr',
      },
      value: {
        title: 'Wert verfolgen',
        description: 'Sehen Sie den aktuellen Marktwert Ihrer gesamten Sammlung auf einen Blick',
      },
      export: {
        title: 'Daten exportieren',
        description: 'Exportieren Sie Ihre Sammlungsdaten zur Verwendung in anderen Anwendungen',
      },
    },
  },
  // Main landing page translations
  landing: {
    hero: {
      title: 'Ihr ultimativer TCG-Begleiter',
      description: 'Suchen, durchstöbern und erstellen Sie Proxies für Ihre Lieblings-Sammelkartenspiele. Verwalten Sie Ihre Sammlung und bauen Sie noch heute Ihr Traumdeck!',
      mtgButton: 'Magic: The Gathering',
      pokemonButton: 'Pokémon',
      stats: {
        mtgProxies: 'Über 50.000 MTG-Proxies erstellt',
        pokemonCards: 'Über 10.000 Pokémon-Karten verfügbar',
        comingSoon: 'Neue TCGs kommen bald',
      },
    },
    tcgSections: {
      title: 'Entdecken Sie Sammelkartenspiele',
      mtg: {
        badge: 'Magic: The Gathering',
        title: 'Das originale Sammelkartenspiel',
        description: 'Erkunden Sie das Multiversum mit Tausenden einzigartiger Karten',
        exploreButton: 'Erkunden',
        features: {
          search: {
            title: 'Karten suchen',
            description: 'Finden Sie jede MTG-Karte nach Name, Typ oder Text',
          },
          sets: {
            title: 'Sets durchsuchen',
            description: 'Erkunden Sie Karten nach Erweiterungsset',
          },
          collection: {
            title: 'Meine Sammlung',
            description: 'Verfolgen und verwalten Sie Ihre MTG-Karten',
          },
          tokens: {
            title: 'Spielmarken & Embleme',
            description: 'Zugriff auf Spielmarken und Embleme für Ihre Spiele',
          },
        },
      },
      pokemon: {
        badge: 'Pokémon',
        title: 'Schnapp sie dir alle',
        description: 'Bauen Sie Ihr Deck mit Ihren Lieblings-Pokémon',
        exploreButton: 'Erkunden',
        features: {
          search: {
            title: 'Karten suchen',
            description: 'Finden Sie jede Pokémon-Karte nach Name oder Typ',
          },
          sets: {
            title: 'Sets durchsuchen',
            description: 'Erkunden Sie Karten vom Basis-Set bis zu den neuesten Erweiterungen',
          },
          collection: {
            title: 'Meine Sammlung',
            description: 'Verfolgen und verwalten Sie Ihre Pokémon-Karten',
          },
          comingSoon: {
            title: 'Demnächst',
            description: 'Weitere Pokémon-Funktionen in Entwicklung',
          },
        },
      },
    },
    crossTcgFeatures: {
      badge: 'TCG-übergreifende Funktionen',
      title: 'Eine Plattform für alle Ihre TCGs',
      description: 'TCG Stacked vereint mehrere Sammelkartenspiele auf einer einheitlichen Plattform und macht es einfach, Ihre gesamte Sammlung zu verwalten.',
      features: {
        unifiedSearch: {
          title: 'Einheitliche Suche',
          description: 'Durchsuchen Sie alle unterstützten TCGs mit leistungsstarken Filtern, um genau das zu finden, wonach Sie suchen. Filtern Sie nach Name, Typ, Set und mehr.',
          mtgLink: 'MTG-Suche',
          pokemonLink: 'Pokémon-Suche',
        },
        collectionManagement: {
          title: 'Sammlungsverwaltung',
          description: 'Verfolgen Sie Ihre gesamte Kartensammlung über mehrere TCGs hinweg. Organisieren Sie nach Spiel, Set und Typ. Überwachen Sie den Wert Ihrer Sammlung im Laufe der Zeit.',
          link: 'Sammlung verwalten',
        },
        deckBuilding: {
          title: 'Deck-Erstellung & Analyse',
          description: 'Erstellen und analysieren Sie Decks für Ihre Lieblings-TCGs. Erhalten Sie Einblicke in Manakurven, Kartentypverteilung und mehr, um Ihr Gameplay zu optimieren.',
          mtgLink: 'MTG-Decks',
          pokemonComingSoon: 'Pokémon-Decks (Demnächst)',
        },
      },
    },
    platformFeatures: {
      title: 'Plattformfunktionen',
      advancedSearch: {
        title: 'Erweiterte Suche',
        description: 'Finden Sie genau das, wonach Sie suchen, mit leistungsstarken Suchfiltern für alle unterstützten TCGs.',
      },
      collectionManagement: {
        title: 'Sammlungsverwaltung',
        description: 'Verfolgen Sie Ihre Kartensammlung, organisieren Sie nach TCG und verwalten Sie Ihr Inventar an einem Ort.',
      },
      proxyCreation: {
        title: 'Proxy-Erstellung',
        description: 'Erstellen Sie hochwertige Proxies für Casual Play und Deck-Tests, ohne Ihr Budget zu sprengen.',
      },
    },
  },
  // Pokemon page translations
  pokemon: {
    hero: {
      title: 'Proxy',
      rotatingWords: ['Pokémon', 'Trainer', 'Energien'],
      description: 'Suchen, durchstöbern und erstellen Sie Proxies für Pokémon-Karten.',
      search: {
        cards: {
          tab: 'Karten',
          placeholder: 'Nach Pokémon-Karten suchen...',
          error: 'Fehler beim Laden zufälliger Pokémon-Karten',
        },
        sets: {
          tab: 'Sets',
          placeholder: 'Nach Pokémon-Kartensets suchen...',
        },
        button: 'Suchen',
        hint: {
          cards: 'Drücken Sie Enter oder klicken Sie auf Suchen, um Ihre Karten zu finden',
          sets: 'Drücken Sie Enter oder klicken Sie auf Suchen, um Ihre Sets zu finden',
        },
        aria: {
          searchIcon: 'Suchsymbol',
          searchInput: {
            cards: 'Nach Pokémon-Karten suchen',
            sets: 'Nach Pokémon-Sets suchen',
          },
        },
      },
      images: {
        cardAlt: 'Pokémon-Kartenbild',
      },
      processedCount: '🎮 Entdecken Sie über {{count}} Pokémon-Karten in unserer Datenbank! 🎮',
    },
    features: {
      section1: {
        badge: 'Proxies drucken',
        title: 'Pokémon Proxy-Karten drucken',
        subtitle: 'Fügen Sie Karten zu Ihrer Druckliste hinzu, drucken Sie sie aus und verwenden Sie sie noch heute in Ihren Decks!',
        features: [
          {
            name: 'Fügen Sie Pokémon-Karten zu Ihrer Druckliste hinzu',
            description: 'Suchen Sie nach beliebigen Pokémon-Karten über die Suchseite oder durchsuchen Sie die Sets und fügen Sie die gewünschten Karten Ihrer Druckliste hinzu.',
          },
          {
            name: 'Drucken Sie Ihre Pokémon-Karten',
            description: 'Sobald Sie alle gewünschten Karten Ihrer Druckliste hinzugefügt haben, können Sie sie ausdrucken und in Ihren Decks verwenden.',
          },
          {
            name: 'Verwenden Sie sie in Ihren Decks',
            description: 'Sobald Sie Ihre Karten ausgedruckt haben, können Sie sie in Ihren Decks für Casual Play und Tests verwenden.',
          },
        ],
        images: {
          cardsScreenshot: 'Pokémon-Karten-Screenshot mit verschiedenen Pokémon-Karten',
        },
      },
      section2: {
        badge: 'Erweiterte Suche',
        title: 'Finden Sie jede Pokémon-Karte mit leistungsstarken Suchwerkzeugen',
        subtitle: 'Unsere erweiterten Suchwerkzeuge machen es einfach, genau die Pokémon-Karten zu finden, nach denen Sie suchen.',
        features: [
          {
            name: 'Nach Set durchsuchen',
            description: 'Erkunden Sie Pokémon-Karten, organisiert nach Set, vom Basis-Set bis zu den neuesten Erweiterungen.',
          },
          {
            name: 'Nach Typ suchen',
            description: 'Finden Sie Pokémon-Karten nach Typ, einschließlich Feuer, Wasser, Pflanze und mehr.',
          },
          {
            name: 'Nach Seltenheit filtern',
            description: 'Filtern Sie Pokémon-Karten nach Seltenheit, von Gewöhnlich bis Ultra-Selten und Geheim-Selten.',
          },
        ],
        images: {
          searchScreenshot: 'Pokémon-Suchoberfläche mit Suchfiltern und Ergebnissen',
        },
      },
      section3: {
        badge: 'Sammlungsverwaltung',
        title: 'Verwalten Sie Ihre Pokémon-Sammlung',
        subtitle: 'Behalten Sie den Überblick über alle Ihre Pokémon-Sammelkartenspiel-Karten an einem Ort mit unseren leistungsstarken Sammlungsverwaltungstools.',
        features: [
          {
            name: 'Verfolgen Sie Ihre Pokémon-Karten',
            description: 'Führen Sie ein detailliertes Inventar aller Ihrer Pokémon-Sammelkartenspiel-Karten an einem Ort',
          },
          {
            name: 'Nach Set organisieren',
            description: 'Sortieren und filtern Sie Ihre Sammlung nach Set, Seltenheit, Typ und mehr',
          },
          {
            name: 'Wert verfolgen',
            description: 'Sehen Sie den aktuellen Marktwert Ihrer gesamten Pokémon-Kartensammlung auf einen Blick',
          },
        ],
        images: {
          collectionScreenshot: 'Pokémon-Sammlungsverwaltungsoberfläche mit organisierten Karten',
        },
      },
    },
    cta: {
      title: 'Bereit loszulegen?',
      subtitle: 'Beginnen Sie noch heute mit dem Erstellen von Pokémon-Karten-Proxies.',
      searchByCard: 'Nach Karte suchen',
      searchBySet: 'Nach Set suchen',
    },
    search: {
      title: 'Pokémon-Kartensuche',
      noResults: 'Keine Pokémon-Karten gefunden, die Ihrer Suche entsprechen.',
      tryAdjusting: 'Versuchen Sie, Ihre Suche anzupassen, um zu finden, wonach Sie suchen.',
    },
    sets: {
      title: 'Pokémon-Kartensets',
      latestSets: 'Neueste Sets',
      upcomingSets: 'Kommende Sets',
      allSets: 'Alle Sets',
      noResults: 'Keine Pokémon-Sets gefunden.',
      searchPlaceholder: 'Sets suchen...',
      sortBy: {
        nameAsc: 'Name (A bis Z)',
        nameDesc: 'Name (Z bis A)',
        releaseDateDesc: 'Erscheinungsdatum (Neueste zuerst)',
        releaseDateAsc: 'Erscheinungsdatum (Älteste zuerst)',
      },
      filterBy: 'Nach Serie filtern',
      allSeries: 'Alle Serien',
    },
    set: {
      notFound: 'Pokémon-Set nicht gefunden.',
      backToSets: 'Zurück zu Sets',
      cards: 'Karten',
      released: 'Veröffentlicht',
      noCards: 'Keine Karten in diesem Set gefunden.',
      tryAdjusting: 'Versuchen Sie, Ihre Suche anzupassen, um zu finden, wonach Sie suchen.',
      sortBy: 'Sortieren nach',
      filterBy: 'Filtern nach',
      allTypes: 'Alle Typen',
      allRarities: 'Alle Seltenheiten',
      searchPlaceholder: 'Karten in diesem Set suchen...',
    },
    card: {
      notFound: 'Pokémon-Karte nicht gefunden.',
      backToSearch: 'Zurück zur Suche',
      addToPrintList: 'Zur Druckliste hinzufügen',
      removeFromPrintList: 'Von Druckliste entfernen',
      inPrintList: 'In Druckliste',
      buyOn: 'Auf TCGplayer kaufen',
      details: 'Details',
      type: 'Typ',
      rarity: 'Seltenheit',
      set: 'Set',
      artist: 'Künstler',
      number: 'Kartennummer',
      flavorText: 'Flavor-Text',
      attacks: 'Attacken',
      abilities: 'Fähigkeiten',
      weakness: 'Schwäche',
      resistance: 'Resistenz',
      retreatCost: 'Rückzugskosten',
      legality: 'Legalität',
      otherVersions: 'Andere Versionen',
      youMightAlsoLike: 'Das könnte dir auch gefallen...',
    },
  },
  // New translations for combined hero component
  hero: {
    game: {
      pokemon: {
        tab: 'Pokémon',
      },
      mtg: {
        tab: 'Magic: The Gathering',
      },
    },
    search: {
      cards: {
        placeholder: 'Nach Karten suchen...',
      },
      sets: {
        placeholder: 'Nach Kartensets suchen...',
      },
      button: 'Suchen',
      hint: {
        cards: 'Drücken Sie Enter oder klicken Sie auf Suchen, um Ihre Karten zu finden',
        sets: 'Drücken Sie Enter oder klicken Sie auf Suchen, um Ihre Sets zu finden',
      },
      aria: {
        searchIcon: 'Suchsymbol',
        searchInput: {
          cards: 'Nach Karten suchen',
          sets: 'Nach Sets suchen',
        },
      },
    },
  },
  // MTG specific translations
  mtg: {
    hero: {
      title: 'Proxy',
      rotatingWords: ['Karten', 'Länder', 'Kreaturen', 'Artefakte', 'Planeswalker'],
      description: 'Suchen, durchstöbern und erstellen Sie Proxies für Magic: The Gathering Sammelkartenspiel-Karten.',
      search: {
        cards: {
          tab: 'Karten',
          placeholder: 'Nach MTG-Karten suchen...',
          error: 'Fehler beim Laden zufälliger MTG-Karten',
        },
        sets: {
          tab: 'Sets',
          placeholder: 'Nach MTG-Kartensets suchen...',
        },
        button: 'Suchen',
        hint: {
          cards: 'Drücken Sie Enter oder klicken Sie auf Suchen, um Ihre Karten zu finden',
          sets: 'Drücken Sie Enter oder klicken Sie auf Suchen, um Ihre Sets zu finden',
        },
        aria: {
          searchIcon: 'Suchsymbol',
          searchInput: {
            cards: 'Nach Magic-Karten suchen',
            sets: 'Nach Magic-Sets suchen',
          },
        },
      },
      images: {
        cardAlt: 'Magic-Kartenbild',
      },
      processedCount: 'Entdecken Sie über {{count}} Magic: The Gathering Karten in unserer Datenbank!',
    },
  },
  customizeCardModal: {
    title: 'Karte mit KI anpassen',
    description: 'Beschreiben Sie, wie Sie diese Karte anpassen möchten. Die KI wird eine neue Version generieren, während der Kartenrahmen und die Struktur erhalten bleiben.',
    buttonText: 'Mit KI anpassen',
    placeholder: 'Beschreiben Sie Ihre benutzerdefinierte Kartenvariante...',
    generateButton: 'Benutzerdefinierte Karte generieren',
    generatingButton: 'Generiere...',
    addToPrintListButton: 'Zur Druckliste hinzufügen',
    successMessage: 'Benutzerdefinierte Karte zur Druckliste hinzugefügt',
    remainingGenerationsOne: '{{count}} verbleibende Generierung in diesem Monat',
    remainingGenerationsOther: '{{count}} verbleibende Generierungen in diesem Monat',
    error: {
      failed: 'Fehler beim Generieren der benutzerdefinierten Karte',
    },
  },
  feedback: {
    buttonLabel: 'Feedback',
    title: 'Teilen Sie Ihr Feedback',
    description: 'Wir schätzen Ihre Meinung, um TCG Stacked zu verbessern. Bitte teilen Sie uns Ihre Gedanken mit.',
    categoryLabel: 'Kategorie',
    categories: {
      bug: 'Fehlerbericht',
      feature: 'Funktionsanfrage',
      improvement: 'Verbesserungsvorschlag',
      general: 'Allgemeines Feedback',
      other: 'Sonstiges',
    },
    messageLabel: 'Ihr Feedback',
    messagePlaceholder: 'Bitte teilen Sie Ihre Gedanken, Vorschläge oder melden Sie ein Problem...',
    ratingLabel: 'Bewerten Sie Ihre Erfahrung (Optional)',
    emailLabel: 'E-Mail (Optional)',
    emailPlaceholder: 'ihre@email.com',
    emailHelp: 'Geben Sie Ihre E-Mail an, wenn Sie möchten, dass wir uns bei Ihnen melden.',
    submitting: 'Wird gesendet...',
    submitButton: 'Feedback senden',
    successMessage: 'Vielen Dank für Ihr Feedback!',
    errorMessage: 'Fehler beim Senden des Feedbacks. Bitte versuchen Sie es erneut.',
  },
  // Pokemon specific translations
  pokemon: {
    advancedFilters: {
      title: 'Erweiterte Filter',
      types: 'Typen',
      rarities: 'Seltenheiten',
      subtypes: 'Untertypen',
      series: 'Serien',
      sets: 'Sets',
      legalities: 'Legalitäten',
      hp: 'KP',
      hpRange: 'KP-Bereich',
      hpMin: 'Min KP',
      hpMax: 'Max KP',
      applyFilters: 'Filter anwenden',
      resetFilters: 'Zurücksetzen',
      close: 'Schließen',
    },
    search: {
      title: 'Pokémon Kartensuche',
      placeholder: 'Pokémon Karten suchen...',
      advancedFilters: 'Erweiterte Filter',
      noResults: 'Keine Ergebnisse gefunden. Versuchen Sie, Ihre Filter anzupassen.',
      error: 'Fehler bei der Suche nach Pokémon-Karten',
    },
    hero: {
      title: 'Proxy',
      rotatingWords: ['Pokémon', 'Trainer', 'Energien', 'Legendäre', 'Glänzende'],
      description: 'Suchen, durchstöbern und erstellen Sie Proxies für Pokémon-Karten.',
      search: {
        cards: {
          tab: 'Karten',
          placeholder: 'Nach Pokémon-Karten suchen...',
          error: 'Fehler beim Laden zufälliger Pokémon-Karten',
        },
        sets: {
          tab: 'Sets',
          placeholder: 'Nach Pokémon-Kartensets suchen...',
        },
        button: 'Suchen',
        hint: {
          cards: 'Drücken Sie Enter oder klicken Sie auf Suchen, um Ihre Karten zu finden',
          sets: 'Drücken Sie Enter oder klicken Sie auf Suchen, um Ihre Sets zu finden',
        },
        aria: {
          searchIcon: 'Suchsymbol',
          searchInput: {
            cards: 'Nach Pokémon-Karten suchen',
            sets: 'Nach Pokémon-Sets suchen',
          },
        },
      },
      images: {
        cardAlt: 'Pokémon-Kartenbild',
      },
      processedCount: 'Entdecken Sie über {{count}} Pokémon-Karten in unserer Datenbank!',
    },
  },
  creditPurchaseModal: {
    title: 'KI-Generierungsguthaben kaufen',
    description: 'Kaufen Sie zusätzliches KI-Generierungsguthaben, um mehr Karten anzupassen.',
    buttonText: 'Guthaben kaufen',
    currentCredits: 'Aktuelles Guthaben',
    selectPackage: 'Guthabenpaket auswählen',
    purchase: 'Jetzt kaufen',
    noCreditsWarning: 'Kein Guthaben verfügbar',
    lowCreditsWarning: 'Niedriges Restguthaben',
    buyCredits: 'Guthaben kaufen',
    remainingGenerationsOne: '{{count}} Guthaben',
    remainingGenerationsOther: '{{count}} Guthaben',
    creditPackages: {
      small: 'Klein',
      medium: 'Mittel',
      large: 'Groß',
    },
    loadingCredits: 'Guthabeninformationen werden geladen...',
    valuePerCredit: '${value}/Guthaben',
    credits: 'Guthaben',
    failedCheckout: 'Fehler beim Erstellen der Bezahlsitzung',
  },
  // KI-Seite Übersetzungen
  ai: {
    pageTitle: 'Passen Sie Ihre Proxy-Karten mit KI-Magic an | TCG Stacked',
    pageDescription: 'Transformieren Sie Ihre Magic: The Gathering-Karten mit KI-generierter Grafik. Exklusiv für Pro-Mitglieder.',
    hero: {
      badge: 'Pro-Funktion',
      title: 'Passen Sie Ihre Proxy-Karten mit KI-Magic an',
      subtitle: 'Erstellen Sie individuelle Grafiken für Ihre Magic: The Gathering Proxies in Sekundenschnelle',
      cta: 'Pro-Mitgliedschaft kostenlos testen',
    },
    features: {
      title: 'Leistungsstarke KI-Funktionen auf Knopfdruck',
      subtitle: 'Unsere KI-Anpassung gibt Ihnen vollständige kreative Kontrolle über Ihre Magic: The Gathering Proxy-Karten',
      cardIntegrity: {
        title: 'Kartenintegrität bewahren',
        description: 'Unsere KI modifiziert nur die Grafik, während der Kartenrahmen, Text, Manasymbole und das Layout perfekt erhalten bleiben.',
      },
      creativity: {
        title: 'Unbegrenzte Kreativität',
        description: 'Verwandeln Sie Ihre Karten mit jedem erdenklichen Thema oder Stil - von Fantasy bis Science-Fiction, von fotorealistisch bis abstrakt.',
      },
      instantResults: {
        title: 'Sofortige Ergebnisse',
        description: 'Generieren Sie individuelle Grafiken in Sekundenschnelle ohne Designkenntnisse. Beschreiben Sie einfach, was Sie sehen möchten.',
      },
      saveCreations: {
        title: 'Speichern Sie Ihre Kreationen',
        description: 'Alle Ihre KI-generierten Karten werden in Ihrem Konto gespeichert, sodass Sie jederzeit von Ihrem Dashboard aus darauf zugreifen können.',
      },
      printAnytime: {
        title: 'Jederzeit drucken',
        description: 'Fügen Sie Ihre benutzerdefinierten Karten jederzeit zu Ihrer Proxy-Liste hinzu und drucken Sie sie zusammen mit dem Rest Ihrer Sammlung.',
      },
    },
    credits: {
      title: 'KI-Generierungsguthaben',
      subtitle: 'Passen Sie Ihre Magic: The Gathering Proxy-Karten mit leistungsstarkem, erschwinglichem und benutzerfreundlichem KI-Generierungsguthaben an.',
      howItWorks: 'So funktioniert das Guthaben',
      step1: {
        number: '1',
        title: 'Guthaben kaufen',
        description: 'in Paketen, die zu Ihren kreativen Bedürfnissen und Ihrem Budget passen',
      },
      step2: {
        number: '2',
        title: 'Individuelle Grafiken generieren',
        description: 'für jede Magic: The Gathering Proxy-Karte mit 1 Guthaben pro Generierung',
      },
      step3: {
        number: '3',
        title: 'Behalten Sie Ihre Nutzung im Blick',
        description: 'in Ihrem Konto-Dashboard und kaufen Sie jederzeit mehr',
      },
      proAdvantage: {
        title: 'Pro-Mitgliedervorteil',
        description: 'Pro-Mitglieder erhalten 5 monatliche KI-Generierungsguthaben als Teil ihres Abonnements. Werden Sie Pro-Mitglied, um Ihr kreatives Potenzial zu maximieren!',
      },
      purchaseButton: 'Jetzt Guthaben kaufen',
      unlockProButton: 'Pro-Mitgliedschaft freischalten',
      packages: {
        title: 'Guthaben-Pakete',
        small: {
          name: 'Klein',
          credits: '5',
          price: '2.99',
          value: '0,60 $/Guthaben',
        },
        medium: {
          name: 'Mittel',
          credits: '15',
          price: '7.99',
          value: '0,53 $/Guthaben',
          popular: 'Beliebt',
        },
        large: {
          name: 'Groß',
          credits: '30',
          price: '13.99',
          value: '0,47 $/Guthaben',
        },
        createDesigns: 'Erstellen Sie {{credits}} einzigartige Kartendesigns',
      },
    },
  },
};

export default translations;
